import { Layout } from 'antd';
import './App.css';
import Dashboard from './Containers/Dashboard';
import Auth from './Containers/Auth';
import LandingPage from './Containers/LandingPage';
import { Route,  BrowserRouter as Router, Switch } from 'react-router-dom';
import { Redirect } from 'react-router-dom/cjs/react-router-dom';
import protected_route from './HOC/protected_route';
import no_auth_route from './HOC/no_auth_route';
import Cookies from 'js-cookie';
import RegistrationForm from './Views/RegistrationForm';
import { useEffect } from 'react';

function App() {
    const authObject =()=> {
      return {
        isAuthenticated: Cookies.get("token_medical_auth") ? true : false
       }
   }

   useEffect(() => {
    const handleKeyDown = (e) => {
      console.log("Event: ", e);
      if(e.key === "F12") {
        e.preventDefault()
        return false
      }
      if((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "I") {
        e.preventDefault()
        return false
      }
      if((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "J") {
        e.preventDefault()
        return false
      }
      if((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "C") {
        e.preventDefault()
        return false
      }
      if((e.ctrlKey || e.metaKey) && e.key === "u") {
        e.preventDefault()
        return false
      }
    }

    const handleContextMenu = (e) => {
      e.preventDefault()
      return false
    }

    document.addEventListener('keydown', handleKeyDown)
    document.addEventListener('contextmenu', handleContextMenu)

    return () => {
      document.removeEventListener('keydown', handleKeyDown)
      document.removeEventListener('contextmenu', handleContextMenu)
    }
   }, [])
  
  return (
    <div className="App">
      <Router>
        <Switch>
            <Route exact path="/" component={()=>no_auth_route({
              authObject:authObject
            })(()=>(<div><LandingPage/></div>))}/>
            {/* <Route exact path="/registrationForm" component={()=>no_auth_route({
              authObject:authObject
            })(()=>(<div><RegistrationForm/></div>))}/> */}
            <Route  path ="/auth" component={()=>no_auth_route({
              authObject:authObject
            })(()=><div ><Auth /></div>)} />
            {/* <Route  path ="/auth" component={() => <Auth />} /> */}
  
            <Route  path ="/dashboard" component={() => protected_route({
                    authObject:authObject,
                    logout:()=>console.log()
                  })(()=><div ><Dashboard logout={()=>console.log()} /></div>)} />

          </Switch>
      </Router>  
    </div>
  );
}

export default App;
